import { UserModuleState, UserModuleAction, USER_MODULE_ACTION, UserTrackData } from ".";
import { RESPONSE_LIMIT } from "../game";

export default function UserReducer(state: UserModuleState, action: UserModuleAction): UserModuleState {

    const { trackId, nodeId, answer } = action.payload || {};
    const trackData = state.tracks.find(t => t.id === trackId);

    switch (action.type) {
        case USER_MODULE_ACTION.CHOOSE_ANSWER:
            let track: UserTrackData = trackData ? { ...trackData } : {
                id: trackId,
                answers: [],
                status: 'active'
            }

            if (track.answers.indexOf(answer) === -1) {
                track.answers.push(answer);
            }


            if (action.payload.isCorrect) {
                track.status = 'completed'
            } else {
                track.status = track.answers.length === RESPONSE_LIMIT ? 'lost' : 'active'
            }

            return {
                ...state,
                tracks: [
                    ...state.tracks.filter(t => t.id !== trackId),
                    track
                ]
            }

        case USER_MODULE_ACTION.SET_LAST_VISITED:
            if (trackData) {
                trackData.lastVisited = nodeId;
                return { ...state };
            } else {
                return {
                    ...state,
                    tracks: [
                        ...state.tracks,
                        {
                            id: trackId,
                            answers: [],
                            status: 'active',
                            lastVisited: nodeId
                        }
                    ]
                }
            }

        case USER_MODULE_ACTION.SET_GAME_TIMER:

            if (!state.gameStartTime && !state.gameEnded) {
                return {
                    ...state,
                    gameStartTime: Date.now()
                }
            } else {
                return { ...state }
            }


        case USER_MODULE_ACTION.RESET:
            return { tracks: [], gameEnded: false }

        case USER_MODULE_ACTION.GAME_END:
            return {
                ...state,
                gameEnded: true
            }

        case USER_MODULE_ACTION.RESTART_TRACK:
            return {
                ...state,
                tracks: [
                    ...state.tracks.filter(t => t.id !== trackId),
                    {
                        id: trackId,
                        answers: [],
                        status: 'active',
                        lastVisited: nodeId
                    }
                ]
            }

        case USER_MODULE_ACTION.END_GAME_SENDED:
            return {
                ...state,
                gameEndSended: true
            }
    }

    return { ...state };
}
